<template>
  <div v-if="showDiscountApplied">
    <div>{{ lang["discount_amount"][language] }}</div>
    
    <div 
    :style="discountAppliedTotalColor"
    v-if="discountIsApplied.type != 'Percentage'"
    v-currency="discountAmount"></div>

    <div 
    :style="discountAppliedTotalColor"
    v-else>
      {{discountIsApplied.value}}% = 
      <span v-currency="discountAmount"></span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import lang from '../../lang'

export default {
  props: ['showDiscountApplied', 'discountIsApplied', 'discountAmount'],
  data() {
    return {
      lang: lang
    }
  },
  computed: {
    ...mapGetters(["language"]),
    ...mapGetters("Theme", [
      "discountAppliedTotalColor"
    ])
  }
}
</script>

<style>

</style>